// Custom hook de cupom do cardápio público — extraído VERBATIM de PublicMenu.js.
// Possui os estados de cupom e os handlers validateCoupon/removeCoupon; recebe via
// props as dependências externas (API, subdomain, customerPhone e getCartTotal).
import { useState } from 'react';
import axios from 'axios';

export default function usePublicMenuCoupon({ API, subdomain, customerPhone, getCartTotal }) {
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [showCouponSuccess, setShowCouponSuccess] = useState(false);

  // 🎟️ Validate Coupon
  const validateCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError('Digite um código de cupom');
      return;
    }

    try {
      setCouponLoading(true);
      setCouponError('');

      const subtotal = getCartTotal();

      // Use public endpoint with subdomain
      const response = await axios.post(`${API}/public/coupons/validate/${subdomain}`, {
        code: couponCode.toUpperCase(),
        order_value: subtotal,
        customer_phone: customerPhone || null
      });

      if (response.data.valid) {
        setAppliedCoupon(response.data.coupon);
        setCouponDiscount(response.data.discount_amount);
        setCouponError('');
        setShowCouponSuccess(true);

        // Hide success message after 3 seconds
        setTimeout(() => setShowCouponSuccess(false), 3000);
      } else {
        setCouponError(response.data.message);
        setAppliedCoupon(null);
        setCouponDiscount(0);
      }
    } catch (error) {
      console.error('Error validating coupon:', error);
      setCouponError(error.response?.data?.detail || 'Erro ao validar cupom');
      setAppliedCoupon(null);
      setCouponDiscount(0);
    } finally {
      setCouponLoading(false);
    }
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
    setCouponDiscount(0);
    setCouponCode('');
    setCouponError('');
    setShowCouponSuccess(false);
  };

  return {
    couponCode,
    setCouponCode,
    appliedCoupon,
    setAppliedCoupon,
    couponDiscount,
    setCouponDiscount,
    couponLoading,
    setCouponLoading,
    couponError,
    setCouponError,
    showCouponSuccess,
    setShowCouponSuccess,
    validateCoupon,
    removeCoupon
  };
}
